import React from "react";
import Helmet from "react-helmet";
import Nav from '../../components/Nav/Nav'
const NotFound = () => (
  <div>
    <Helmet title="Not Found" />
    <Nav></Nav>
    <h1>Page Not Found!</h1>
  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// /src/containers/NotFound/NotFound.js